import React, { FC } from 'react';
import { ThemeProvider as SCThemeProvider } from 'styled-components';
import theme from '../../../config/theme';
import { StylesProvider, ThemeProvider } from '@material-ui/styles';
import { CssBaseline } from '@material-ui/core';
import { AppInfo, AuthorizationRoot } from './index';
import { IdleTimer } from '../../shared/components';
import { BreakpointIndicator } from '../../../config/theme/BreakpointIndicator';
import { Route } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { DataLoggingContextProvider } from '../../shared/data-logging';
import { MathJaxContext } from 'better-react-mathjax/MathJaxContext';
import { FullscreenModeShell } from './FullscreenModeShell';

const AppShell: FC = () => {
  return (
    <SCThemeProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <StylesProvider injectFirst>
          <CssBaseline />
          <IdleTimer>
            <QueryParamProvider ReactRouterRoute={Route}>
              <DataLoggingContextProvider>
                <MathJaxContext>
                  <FullscreenModeShell>
                    <AuthorizationRoot />
                  </FullscreenModeShell>
                </MathJaxContext>
              </DataLoggingContextProvider>
            </QueryParamProvider>
          </IdleTimer>
          <AppInfo />
          <BreakpointIndicator />
        </StylesProvider>
      </ThemeProvider>
    </SCThemeProvider>
  );
};

export default AppShell;
